import { useState, useEffect } from "react";
import { ALL_LEAGUES } from "../constants";
import { api } from "../api";
import { useAdmin } from "../AdminContext";

const RAILWAY_URL = "https://web-production-c0e77.up.railway.app";
const SUPER = "Süper Lig";

const DAYS = [
  { value: "monday", label: "Pzt" }, { value: "tuesday", label: "Sal" },
  { value: "wednesday", label: "Çar" }, { value: "thursday", label: "Per" },
  { value: "friday", label: "Cum" }, { value: "saturday", label: "Cmt" },
  { value: "sunday", label: "Paz" },
];
// ── Palet ──────────────────────────────────────────────────────────────────
const C = {
  ink: "#0f172a", sub: "#64748b", dim: "#94a3b8", line: "#e2e8f0",
  bg: "#f1f5f9", card: "#ffffff", accent: "#2563eb", accentBg: "#eff6ff",
  ok: "#16a34a", okBg: "#f0fdf4", okLine: "#bbf7d0",
  warn: "#b45309", warnBg: "#fffbeb", danger: "#dc2626",
};

// ── Ortak parçalar ─────────────────────────────────────────────────────────
function Card({ icon, title, desc, right, children }) {
  return (
    <div style={{ background: C.card, borderRadius: 14, padding: "18px 20px",
                  border: `1px solid ${C.line}`, boxShadow: "0 1px 2px rgba(15,23,42,.04)" }}>
      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12, marginBottom: children ? 16 : 0 }}>
        <div>
          <div style={{ fontWeight: 700, fontSize: 14.5, color: C.ink, display: "flex", alignItems: "center", gap: 8 }}>
            {icon && <span style={{ fontSize: 16 }}>{icon}</span>}{title}
          </div>
          {desc && <div style={{ fontSize: 12.5, color: C.sub, marginTop: 4, lineHeight: 1.5 }}>{desc}</div>}
        </div>
        {right}
      </div>
      {children}
    </div>
  );
}

function Switch({ value, onChange, disabled }) {
  return (
    <div onClick={() => !disabled && onChange(!value)} style={{
      width: 40, height: 23, borderRadius: 12, background: value ? C.accent : "#cbd5e1",
      position: "relative", transition: "background .2s", flexShrink: 0,
      cursor: disabled ? "default" : "pointer", opacity: disabled ? 0.7 : 1 }}>
      <div style={{ position: "absolute", top: 3, left: value ? 20 : 3, width: 17, height: 17,
                    borderRadius: 9, background: "#fff", transition: "left .2s", boxShadow: "0 1px 2px rgba(0,0,0,.25)" }} />
    </div>
  );
}

function Toggle({ value, onChange, label, desc }) {
  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 12, cursor: "pointer" }} onClick={() => onChange(!value)}>
        <Switch value={value} onChange={onChange} />
        <span style={{ fontSize: 14, color: C.ink, fontWeight: 500 }}>{label}</span>
      </div>
      {desc && <div style={{ fontSize: 12, color: C.dim, marginTop: 6, marginLeft: 52, lineHeight: 1.5 }}>{desc}</div>}
    </div>
  );
}

function Segmented({ options, value, onChange }) {
  return (
    <div style={{ display: "inline-flex", background: "#f1f5f9", borderRadius: 10, padding: 3, gap: 3, flexWrap: "wrap" }}>
      {options.map(o => {
        const on = value === o.value;
        return (
          <button key={o.value} onClick={() => onChange(o.value)} style={{
            padding: "7px 16px", borderRadius: 8, border: "none", cursor: "pointer",
            fontSize: 13, fontWeight: 600, background: on ? "#fff" : "transparent",
            color: on ? C.accent : C.sub, boxShadow: on ? "0 1px 2px rgba(15,23,42,.12)" : "none" }}>{o.label}</button>
        );
      })}
    </div>
  );
}

// Süper Lig kilitli satırı (hem Gösterim hem Analiz sekmesinde)
function SuperLigLocked({ note }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 16px",
                  background: C.okBg, border: `1px solid ${C.okLine}`, borderRadius: 11 }}>
      <span style={{ fontSize: 18 }}>🇹🇷</span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: "#14532d" }}>{SUPER} <span style={{ fontSize: 12 }}>🔒</span></div>
        <div style={{ fontSize: 12, color: "#3f6212" }}>{note}</div>
      </div>
      <span style={{ fontSize: 11, fontWeight: 700, color: C.ok, background: "#fff", border: `1px solid ${C.okLine}`, borderRadius: 20, padding: "2px 10px" }}>HEP AKTİF</span>
    </div>
  );
}

// ── Giriş ekranı ────────────────────────────────────────────────────────────
function LoginScreen({ onLogin }) {
  const [pw, setPw] = useState("");
  const [error, setError] = useState(false);
  const [checking, setChecking] = useState(false);
  const handleSubmit = async () => {
    if (!pw || checking) return;
    setChecking(true);
    try {
      const r = await fetch(`${RAILWAY_URL}/api/admin/settings`, { headers: { "X-Admin-Secret": pw } });
      if (r.ok) onLogin(pw); else { setError(true); setTimeout(() => setError(false), 2000); }
    } catch (e) { setError(true); setTimeout(() => setError(false), 2000); }
    setChecking(false);
  };
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", background: C.bg }}>
      <div style={{ background: C.card, borderRadius: 16, padding: 40, width: 340, boxShadow: "0 10px 40px rgba(15,23,42,.12)", border: `1px solid ${C.line}` }}>
        <div style={{ width: 48, height: 48, borderRadius: 12, background: "#0f172a", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, marginBottom: 16 }}>🔧</div>
        <div style={{ fontSize: 19, fontWeight: 800, color: C.ink }}>Admin Paneli</div>
        <div style={{ fontSize: 13, color: C.dim, marginBottom: 24 }}>FootballAgents kontrol merkezi</div>
        <input type="password" value={pw} onChange={e => setPw(e.target.value)} onKeyDown={e => e.key === "Enter" && handleSubmit()} placeholder="Şifre"
          style={{ width: "100%", padding: "11px 13px", border: `1px solid ${error ? C.danger : C.line}`, borderRadius: 10, fontSize: 14, outline: "none", boxSizing: "border-box", background: error ? "#fef2f2" : "#fff" }} />
        {error && <div style={{ color: C.danger, fontSize: 12, marginTop: 6 }}>Hatalı şifre</div>}
        <button onClick={handleSubmit} disabled={checking} style={{ width: "100%", marginTop: 14, padding: "11px 0", borderRadius: 10, background: checking ? "#94a3b8" : C.ink, color: "#fff", border: "none", fontSize: 14, fontWeight: 700, cursor: checking ? "not-allowed" : "pointer" }}>
          {checking ? "Kontrol ediliyor..." : "Giriş Yap"}
        </button>
      </div>
    </div>
  );
}

// ── Ana panel ─────────────────────────────────────────────────────────────
function AdminPanel({ secret, onExit, onAnalysisStart, onSettingsSaved }) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [triggering, setTriggering] = useState(false);
  const [trigMsg, setTrigMsg] = useState("");
  const [trigScope, setTrigScope] = useState("superlig");
  const [activeTab, setActiveTab] = useState("genel");
  // Tahmin yönetimi
  const [preds, setPreds] = useState([]);
  const [predsLoading, setPredsLoading] = useState(false);
  const [predLeague, setPredLeague] = useState("");
  const [delBusy, setDelBusy] = useState(false);

  useEffect(() => {
    api.adminGetSettings(secret).then(d => { setSettings(d); setLoading(false); }).catch(() => setLoading(false));
  }, [secret]);

  const loadPreds = () => {
    setPredsLoading(true);
    api.adminListPredictions(secret, predLeague)
      .then(d => { setPreds(d.predictions || []); setPredsLoading(false); })
      .catch(() => setPredsLoading(false));
  };
  useEffect(() => { if (activeTab === "tahminler") loadPreds(); }, [activeTab, predLeague]); // eslint-disable-line

  const delOne = async (id) => {
    setDelBusy(true);
    const r = await api.deletePrediction(id, secret);
    if (r && r.detail === "Unauthorized") { window.alert("Yetki reddedildi — oturum düşmüş olabilir."); setDelBusy(false); return; }
    setPreds(prev => prev.filter(p => p.id !== id));
    setDelBusy(false);
  };
  const delLeague = async () => {
    if (!predLeague) return;
    if (!window.confirm(`"${predLeague}" liginin TÜM tahminleri silinecek. Emin misin?`)) return;
    setDelBusy(true);
    await api.adminDeleteByLeague(secret, predLeague);
    setDelBusy(false);
    loadPreds();
  };

  const save = async () => {
    setSaving(true);
    try { await api.adminSaveSettings(secret, settings); setSaved(true); setTimeout(() => setSaved(false), 2500); if (onSettingsSaved) onSettingsSaved(); } catch (e) {}
    setSaving(false);
  };

  const triggerWeekly = async () => {
    setTriggering(true); setTrigMsg("");
    try {
      const leagues = trigScope === "superlig" ? [SUPER] : null;
      const d = await api.adminTriggerWeekly(secret, leagues);
      setTrigMsg(d.message || "Başlatıldı");
      if (onAnalysisStart) setTimeout(onAnalysisStart, 1000);
    } catch (e) { setTrigMsg("Hata oluştu"); }
    setTriggering(false);
  };

  // Lig config güncelle (leagues sözlüğü)
  const cfg = (lg) => (settings.leagues || {})[lg] || { analiz: false, gosterim: false, oto: false, gun: "wednesday", saat: "06:00" };
  const setLeague = (lg, patch) => {
    const leagues = { ...(settings.leagues || {}) };
    leagues[lg] = { analiz: false, gosterim: false, oto: false, gun: "wednesday", saat: "06:00", ...(leagues[lg] || {}), ...patch };
    setSettings({ ...settings, leagues });
  };

  if (loading) return <div style={{ padding: 40, textAlign: "center", color: C.dim }}>Yükleniyor...</div>;
  if (!settings) return <div style={{ padding: 40, textAlign: "center", color: C.danger }}>Bağlantı hatası</div>;

  const others = ALL_LEAGUES.filter(l => l !== SUPER);
  const gosterimSayi = others.filter(l => cfg(l).gosterim).length + 1; // +Süper Lig
  const analizSayi = others.filter(l => cfg(l).analiz).length + 1;

  const tabs = [
    { id: "genel",   label: "⚙️ Genel" },
    { id: "gosterim", label: "👁️ Gösterim" },
    { id: "analiz",  label: "🤖 Analiz" },
    { id: "tahminler", label: "🗑️ Tahminler" },
  ];

  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column", background: C.bg }}>
      {/* Header */}
      <div style={{ padding: "16px 24px", background: "linear-gradient(90deg,#0f172a,#1e293b)", color: "#fff", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ width: 34, height: 34, borderRadius: 9, background: "rgba(255,255,255,.1)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 17 }}>🔧</div>
          <div>
            <div style={{ fontSize: 17, fontWeight: 800, lineHeight: 1.1 }}>Admin Paneli</div>
            <div style={{ fontSize: 11.5, color: "#94a3b8" }}>FootballAgents · kontrol merkezi</div>
          </div>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={save} disabled={saving} style={{ padding: "8px 18px", borderRadius: 9, border: "none", background: saved ? C.ok : C.accent, color: "#fff", fontSize: 13, fontWeight: 700, cursor: saving ? "default" : "pointer" }}>
            {saving ? "Kaydediliyor..." : saved ? "✓ Kaydedildi" : "Kaydet"}
          </button>
          <button onClick={onExit} style={{ padding: "8px 14px", borderRadius: 9, border: "1px solid #334155", background: "transparent", color: "#cbd5e1", fontSize: 13, cursor: "pointer" }}>✕ Çıkış</button>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display: "flex", background: C.card, borderBottom: `1px solid ${C.line}`, padding: "0 24px", gap: 4, overflowX: "auto" }}>
        {tabs.map(t => (
          <button key={t.id} onClick={() => setActiveTab(t.id)} style={{ padding: "13px 16px", border: "none", background: "none", cursor: "pointer", whiteSpace: "nowrap", fontSize: 13.5, fontWeight: activeTab === t.id ? 700 : 500, color: activeTab === t.id ? C.accent : C.sub, borderBottom: activeTab === t.id ? `2.5px solid ${C.accent}` : "2.5px solid transparent", marginBottom: -1 }}>{t.label}</button>
        ))}
      </div>

      {/* İçerik */}
      <div style={{ flex: 1, overflowY: "auto", padding: 24 }}>

        {/* ══ GENEL ══ */}
        {activeTab === "genel" && (
          <div style={{ maxWidth: 560, display: "flex", flexDirection: "column", gap: 16 }}>
            <Card icon="🧠" title="AI Sağlayıcı" desc="Analizleri hangi model üretsin.">
              <Segmented value={settings.ai_provider} onChange={p => setSettings({ ...settings, ai_provider: p })} options={[{ value: "gpt", label: "GPT-4o" }, { value: "claude", label: "Claude" }]} />
            </Card>
            <Card icon="🔒" title="Kullanıcı İzinleri">
              <Toggle value={settings.user_analysis_enabled ?? false} onChange={v => setSettings({ ...settings, user_analysis_enabled: v })} label="Ziyaretçiler analiz yapabilir" desc="Kapalıysa 'Analiz Et' butonu gizlenir — kullanıcılar yalnızca mevcut tahminleri görür." />
            </Card>
            <Card icon="📊" title="Veri & Limitler">
              <Toggle value={settings.odds_enabled} onChange={v => setSettings({ ...settings, odds_enabled: v })} label="Piyasa oranları aktif (The Odds API)" />
              <div style={{ marginTop: 16, borderTop: `1px solid ${C.line}`, paddingTop: 14 }}>
                <div style={{ fontSize: 13, color: C.ink, fontWeight: 500, marginBottom: 6 }}>Haftalık maksimum tahmin sayısı</div>
                <input type="number" value={settings.max_predictions_per_week} onChange={e => setSettings({ ...settings, max_predictions_per_week: parseInt(e.target.value) || 50 })} style={{ width: 110, padding: "8px 11px", border: `1px solid ${C.line}`, borderRadius: 8, fontSize: 13 }} />
              </div>
            </Card>
          </div>
        )}

        {/* ══ GÖSTERİM ══ */}
        {activeTab === "gosterim" && (
          <div style={{ maxWidth: 620, display: "flex", flexDirection: "column", gap: 14 }}>
            <div style={{ fontSize: 12.5, color: C.sub, lineHeight: 1.55 }}>
              <b>Gösterim açık</b> ligler, üretilen tahminleri web'de <b>herkese açık</b> gösterir
              (giriş gerektirmez, Süper Lig gibi). Kapalıysa tahminler yalnızca kilidini açan kullanıcıya görünür.
              Bu, analizden bağımsızdır — <i>bir lig analiz edilmeden de listede durabilir.</i>
            </div>
            <SuperLigLocked note="Tahminleri her zaman herkese açık gösterilir." />
            <Card icon="👁️" title={`Herkese Açık Ligler (${gosterimSayi} / ${ALL_LEAGUES.length})`}>
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {others.map(lg => {
                  const c = cfg(lg);
                  return (
                    <div key={lg} style={{ display: "flex", alignItems: "center", gap: 12, padding: "9px 4px", borderBottom: `1px solid ${C.line}` }}>
                      <Switch value={!!c.gosterim} onChange={v => setLeague(lg, { gosterim: v })} />
                      <span style={{ fontSize: 13.5, color: C.ink, fontWeight: 500, flex: 1 }}>{lg}</span>
                      {c.gosterim && !c.analiz && (
                        <span style={{ fontSize: 11, color: C.warn }}>⚠ analiz kapalı — gösterilecek tahmin yok</span>
                      )}
                    </div>
                  );
                })}
              </div>
            </Card>
          </div>
        )}

        {/* ══ ANALİZ ══ */}
        {activeTab === "analiz" && (
          <div style={{ maxWidth: 620, display: "flex", flexDirection: "column", gap: 14 }}>
            <div style={{ fontSize: 12.5, color: C.sub, lineHeight: 1.55 }}>
              <b>Analiz açık</b> ligler için FootballAgents tahmin üretir. İstersen her lige
              <b> haftalık otomatik</b> analiz (gün + saat, TRT) tanımla — backend zamanlayıcısı çalıştırır.
            </div>
            <SuperLigLocked note="Otomatik: her Salı 06:00 (TRT) · pg_cron ile." />

            <Card icon="🤖" title={`Analiz Edilen Ligler (${analizSayi} / ${ALL_LEAGUES.length})`}
              desc="Aç → tahmin üretilir. Otomatik → belirtilen gün/saatte her hafta kendiliğinden.">
              <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                {others.map(lg => {
                  const c = cfg(lg);
                  return (
                    <div key={lg} style={{ padding: "10px 4px", borderBottom: `1px solid ${C.line}` }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                        <Switch value={!!c.analiz} onChange={v => setLeague(lg, { analiz: v })} />
                        <span style={{ fontSize: 13.5, color: C.ink, fontWeight: 500, flex: 1 }}>{lg}</span>
                        {c.analiz && (
                          <label style={{ display: "flex", alignItems: "center", gap: 7, cursor: "pointer" }}>
                            <span style={{ fontSize: 12, color: c.oto ? C.accent : C.dim, fontWeight: 600 }}>Otomatik</span>
                            <Switch value={!!c.oto} onChange={v => setLeague(lg, { oto: v })} />
                          </label>
                        )}
                      </div>
                      {c.analiz && c.oto && (
                        <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 10, marginLeft: 52, flexWrap: "wrap" }}>
                          <span style={{ fontSize: 12, color: C.sub }}>Her</span>
                          <select value={c.gun || "wednesday"} onChange={e => setLeague(lg, { gun: e.target.value })}
                            style={{ padding: "5px 8px", border: `1px solid ${C.line}`, borderRadius: 7, fontSize: 12.5, background: "#fff" }}>
                            {DAYS.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
                          </select>
                          <input type="time" value={c.saat || "06:00"} onChange={e => setLeague(lg, { saat: e.target.value })}
                            style={{ padding: "5px 8px", border: `1px solid ${C.line}`, borderRadius: 7, fontSize: 12.5 }} />
                          <span style={{ fontSize: 11.5, color: C.dim }}>TRT</span>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </Card>

            {/* Manuel tetikleme */}
            <Card icon="▶️" title="Manuel Tetikleme" desc="Hemen analiz et. Zaten analiz edilmiş maçlar atlanır (masrafsız).">
              <div style={{ marginBottom: 14 }}>
                <div style={{ fontSize: 12.5, color: C.sub, marginBottom: 8 }}>Kapsam</div>
                <Segmented value={trigScope} onChange={setTrigScope} options={[
                  { value: "superlig", label: "⚽ Sadece Süper Lig" },
                  { value: "active", label: `🗂️ Analiz açık ligler (${analizSayi})` },
                ]} />
              </div>
              <button onClick={triggerWeekly} disabled={triggering} style={{ padding: "10px 22px", borderRadius: 9, border: "none", background: triggering ? "#94a3b8" : C.ok, color: "#fff", fontSize: 13.5, fontWeight: 700, cursor: triggering ? "not-allowed" : "pointer" }}>
                {triggering ? "⏳ Başlatılıyor..." : "🚀 Analizi Başlat"}
              </button>
              {trigMsg && (
                <div style={{ marginTop: 12, fontSize: 13, color: C.ok, fontWeight: 600, background: C.okBg, border: `1px solid ${C.okLine}`, borderRadius: 8, padding: "8px 11px" }}>✓ {trigMsg}</div>
              )}
            </Card>
          </div>
        )}

        {/* ══ TAHMİNLER (yönetim/silme) ══ */}
        {activeTab === "tahminler" && (
          <div style={{ maxWidth: 760, display: "flex", flexDirection: "column", gap: 14 }}>
            <div style={{ fontSize: 12.5, color: C.sub, lineHeight: 1.55 }}>
              Kayıtlı <b>tüm</b> tahminler (public + kullanıcı, hepsi). Yanlış/eksik analiz edilmiş
              maçları buradan silebilirsin — silinen maç bir sonraki analizde yeniden üretilir.
            </div>
            <Card icon="🗑️" title={`Tahminler (${preds.length})`}
              right={
                <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                  <select value={predLeague} onChange={e => setPredLeague(e.target.value)}
                    style={{ padding: "6px 10px", border: `1px solid ${C.line}`, borderRadius: 8, fontSize: 12.5, background: "#fff" }}>
                    <option value="">🌍 Tüm ligler</option>
                    {ALL_LEAGUES.map(l => <option key={l} value={l}>{l}</option>)}
                  </select>
                  <button onClick={loadPreds} disabled={predsLoading} style={{ padding: "6px 12px", borderRadius: 8, border: `1px solid ${C.line}`, background: "#fff", fontSize: 12.5, cursor: "pointer", color: C.sub }}>↻ Yenile</button>
                  {predLeague && preds.length > 0 && (
                    <button onClick={delLeague} disabled={delBusy} style={{ padding: "6px 12px", borderRadius: 8, border: "1px solid #fecaca", background: "#fff", fontSize: 12.5, cursor: "pointer", color: C.danger, fontWeight: 600 }}>
                      🗑️ Bu ligi temizle ({preds.length})
                    </button>
                  )}
                </div>
              }>
              {predsLoading ? (
                <div style={{ padding: 24, textAlign: "center", color: C.dim, fontSize: 13 }}>Yükleniyor...</div>
              ) : preds.length === 0 ? (
                <div style={{ padding: 24, textAlign: "center", color: C.dim, fontSize: 13 }}>Kayıt yok.</div>
              ) : (
                <div style={{ overflowX: "auto" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12.5, minWidth: 520 }}>
                    <thead>
                      <tr style={{ color: C.dim, fontSize: 11, textTransform: "uppercase", letterSpacing: ".04em" }}>
                        <th style={{ textAlign: "left", padding: "6px 8px", fontWeight: 700 }}>Tarih</th>
                        <th style={{ textAlign: "left", padding: "6px 8px", fontWeight: 700 }}>Maç</th>
                        <th style={{ textAlign: "left", padding: "6px 8px", fontWeight: 700 }}>Lig</th>
                        <th style={{ textAlign: "left", padding: "6px 8px", fontWeight: 700 }}>Tahmin</th>
                        <th style={{ padding: "6px 8px" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {preds.map(p => (
                        <tr key={p.id} style={{ borderTop: `1px solid ${C.line}` }}>
                          <td style={{ padding: "8px", color: C.sub, whiteSpace: "nowrap" }}>{p.match_date}</td>
                          <td style={{ padding: "8px", color: C.ink, fontWeight: 500 }}>{p.home} <span style={{ color: C.dim }}>–</span> {p.away}</td>
                          <td style={{ padding: "8px", color: C.sub, whiteSpace: "nowrap" }}>{p.league}</td>
                          <td style={{ padding: "8px", color: C.ink }}>{p.gpt_prediction || "—"} {p.gpt_confidence != null && <span style={{ color: C.dim, fontSize: 11 }}>({p.gpt_confidence})</span>}</td>
                          <td style={{ padding: "8px", textAlign: "right" }}>
                            <button onClick={() => delOne(p.id)} disabled={delBusy} style={{ padding: "4px 9px", borderRadius: 6, border: "1px solid #fecaca", background: "#fff", color: C.danger, fontSize: 12, cursor: "pointer" }}>🗑️</button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </Card>
          </div>
        )}
      </div>
    </div>
  );
}

// ── Export ────────────────────────────────────────────────────────────────
export default function Admin({ onExit, onAnalysisStart, onSettingsSaved }) {
  const { secret, login, logout } = useAdmin();
  const handleExit = () => { logout(); if (onExit) onExit(); };
  if (!secret) return <LoginScreen onLogin={login} />;
  return <AdminPanel secret={secret} onExit={handleExit} onAnalysisStart={onAnalysisStart} onSettingsSaved={onSettingsSaved} />;
}
